import { Avatar, Button } from '@springcare/sh-component-library';
import { Flex, Menu, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { useRouter } from 'next/router';
import routes from 'routes';

export const ProfileMenu = ({ sideNavOpen, ...rest }) => {
  const { user } = useContext(AuthContext);
  const name = `${user?.first_name} ${user?.last_name}`;
  const router = useRouter();
  return (
    <Menu {...rest} direction="rtl">
      <MenuButton
        as={Button}
        width="100%"
        p={2}
        justifyContent={'flex-start'}
        size="sm"
        variant="low-emphasis"
        backgroundColor="white"
      >
        <Flex width="100%" gap={2}>
          <Avatar height={'26px'} width="26px" fontSize="12px" name={name} />
          <Text whiteSpace="nowrap" overflow="hidden" transition="color 0.3s ease">
            {name}
          </Text>
        </Flex>
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => router.push(routes.Logout.as)}>Logout</MenuItem>
      </MenuList>
    </Menu>
  );
};
